import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Typography from "@mui/material/Typography";
import jwt_decode from 'jwt-decode';
import "./MenuKitchen.css"
import {
    Autocomplete,
    Grid,
    TextField,
    Button,
    Box,
    Dialog

} from "@mui/material";


const MenuKitchen = (props) => {
    const [selections, setSelections] = useState({});

    useEffect(() => {
        const initialSelections = props.kitchens.reduce((acc, kitchen) => {
            kitchen.menus.forEach(menu => {
                const defaultValue = kitchen.kitchens.find(k => k.id === menu.kitchenId);
                acc[menu.id] = defaultValue || null;
            });
            return acc;
        }, {});
        setSelections(initialSelections);
    }, [props.kitchens]);


    useEffect(() => {
        props.getKitchens(selections)
        console.log(selections) 
    }, [selections]);

    const handleSelectionChange = (menuId, newValue) => {
        setSelections(prev => ({
            ...prev,
            [menuId]: newValue
        }));
    };

    return (
        <div>
            {props.kitchens.map((kitchen, idx) => (
                kitchen.menus.length > 0 && (
                    <div key={kitchen.id}>
                        <div className={`mb-3 ${idx > 0 ? "mt-5" : "mt-2"}`}>
                            <Grid item xs={12}>
                                <Typography variant="h5">
                                    {kitchen.restaurantName} 
                                </Typography>
                            </Grid>
                        </div>
                        <div className="menu-kitchen-input">
                            {kitchen.menus.map((menu) => (
                                <div key={menu.id} className="w-100 pe-4">
                                    <Grid item xs={12} sm={5} sx={{ paddingRight: { xs: '0', sm: '1rem' } }}>
                                        <Typography sx={{ paddingY: '.2rem' }}>
                                            {menu.menuName}
                                        </Typography>
<Autocomplete
    id={`single-select-${menu.id}`}
    options={kitchen.kitchens.filter(k => {
        const name = k.kitchenName?.toLowerCase();
        return name !== "manager view" && name !== "waiter view";
    })}
    getOptionLabel={(option) => option.kitchenName}
    value={selections[menu.id] || null}
    onChange={(event, newValue) => handleSelectionChange(menu.id, newValue)}
    renderInput={(params) => (
        <TextField {...params} label="Select Option" variant="outlined" />
    )}
    sx={{ width: '100%', paddingY: '.5rem' }}
/>

                                    </Grid>
                                </div>
                            ))}
                        </div>
                    </div>
                )))}
        </div>
    );
};

export default MenuKitchen;